import React from 'react';
import keys from 'lodash/keys';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getVisibleCategoricalSelectedParametersNames, getCategoricalSummary } from 'store/dataset';
import { getOptionListForDropDown, getLevelsOptionsForChosenVariable } from 'calculators/inferentialStatistics/oneSampleT';
import {
  getFirstVariable,
  getSecondVariable,
  setNumberOfSuccessFirst,
  setNumberOfSuccessSecond,
  setDataTwoSampleProportion,
  resetDropDownsForFirstVariable,
  resetDropDownsForSecondVariable
} from 'store/form/inferentialStatistics/twoSampleProportion';

import { valueTwoSampleProportion } from '../defaultValueForProcedures';

import TwoSampleProportionComponent from './Component';

class TwoSampleProportionContainer extends React.PureComponent {

  getCategoricalOptionsDataSet = variableInAnotherDropDown => {
    const { categoricalSelectedParametersNames, isFrequencyTable } = this.props;
    return getOptionListForDropDown({
      selectedParametersNames: categoricalSelectedParametersNames,
      variableInAnotherDropDown,
      isFrequencyTable
    });
  };

  getLevelsOptions = variable => {
    const { categoricalSummary } = this.props;
    return getLevelsOptionsForChosenVariable(variable, categoricalSummary);
  };

  handleOptionsChangeFirst = (_, newVariable) => {
    this.props.handleOptionsChangeFirst(newVariable);
  };

  handleOptionsChangeSecond = (_, newVariable) => {
    this.props.handleOptionsChangeSecond(newVariable);
  };

  handleLevelsOptionsChangeFirst = (_, newVariable) => {
    this.props.handleLevelsOptionsChangeFirst(newVariable);
  };

  handleLevelsOptionsChangeSecond = (_, newVariable) => {
    this.props.handleLevelsOptionsChangeSecond(newVariable);
  };

  render () {
    const { firstVariable, secondVariable } = this.props;
    return (
      <TwoSampleProportionComponent
        firstVariable={firstVariable}
        secondVariable={secondVariable}
        getCategoricalOptionsDataSet={this.getCategoricalOptionsDataSet}
        getFirstLevelsOptions={this.getLevelsOptions(firstVariable)}
        getSecondLevelsOptions={this.getLevelsOptions(secondVariable)}
        onHandleOptionsChangeFirst={this.handleOptionsChangeFirst}
        onHandleOptionsChangeSecond={this.handleOptionsChangeSecond}
        onHandleLevelsOptionsChangeSecond={this.handleLevelsOptionsChangeSecond}
        onHandleLevelsOptionsChangeFirst={this.handleLevelsOptionsChangeFirst}
        onHandleInputsFirstVariable={this.props.handleInputsFirstVariable}
        onHandleInputsSecondVariable={this.props.handleInputsSecondVariable}
      />
    );
  }
}

TwoSampleProportionContainer.propTypes = {
  handleOptionsChangeFirst: PropTypes.func.isRequired,
  handleOptionsChangeSecond: PropTypes.func.isRequired,
  handleInputsFirstVariable: PropTypes.func.isRequired,
  handleInputsSecondVariable: PropTypes.func.isRequired,
  handleLevelsOptionsChangeFirst: PropTypes.func.isRequired,
  handleLevelsOptionsChangeSecond: PropTypes.func.isRequired,
  categoricalSelectedParametersNames: PropTypes.arrayOf(PropTypes.string),
  isFrequencyTable: PropTypes.bool.isRequired,
  categoricalSummary: PropTypes.object,
  firstVariable: PropTypes.string,
  secondVariable: PropTypes.string
};

const mapStateToProps = state => ({
  categoricalSelectedParametersNames: getVisibleCategoricalSelectedParametersNames(
    state
  ),
  firstVariable: getFirstVariable(state),
  secondVariable: getSecondVariable(state),
  categoricalSummary: getCategoricalSummary(state)
});

const mapDispatchToProps = {
  handleOptionsChangeFirst: newVariable => (dispatch, getState) => {
    let data = {
      numberOfTrialsFirst: valueTwoSampleProportion.numberOfTrialsFirst,
      numberOfSuccessFirst: valueTwoSampleProportion.numberOfSuccessFirst,
      successGroupFirst: valueTwoSampleProportion.successGroupFirst
    };
    if (newVariable) {
      const { categoricalSummary } = getState().dataset.summary;
      const chosenOption = categoricalSummary[newVariable];

      const [firstLevel] = keys(chosenOption.levels);

      if (chosenOption && firstLevel && chosenOption.levels[firstLevel]) {
        data = {
          numberOfTrialsFirst: chosenOption.count,
          successGroupFirst: chosenOption.levels[firstLevel].name,
          numberOfSuccessFirst: chosenOption.levels[firstLevel].count
        };
      }
    }
    return setDataTwoSampleProportion({ ...data, firstVariable: true })(dispatch);
  },
  handleLevelsOptionsChangeFirst: newLevel => (dispatch, getState) => {
    if (!newLevel) {
      return dispatch(setNumberOfSuccessFirst(valueTwoSampleProportion.numberOfSuccessFirst));
    }

    const state = getState();
    const variableOption = getFirstVariable(state);

    const categoricalSummary = getCategoricalSummary(state);
    const chosenOption = categoricalSummary[variableOption];

    if (variableOption && chosenOption && chosenOption.levels[newLevel]) {
      const numberOfSuccess = chosenOption.levels[newLevel].count;

      return dispatch(setNumberOfSuccessFirst(numberOfSuccess));
    }
    return dispatch();
  },
  handleOptionsChangeSecond: newVariable => (dispatch, getState) => {
    let data = {
      numberOfTrialsSecond: valueTwoSampleProportion.numberOfTrialsSecond,
      numberOfSuccessSecond: valueTwoSampleProportion.numberOfSuccessSecond,
      successGroupSecond: valueTwoSampleProportion.successGroupSecond
    };
    if (newVariable) {
      const { categoricalSummary } = getState().dataset.summary;
      const chosenOption = categoricalSummary[newVariable];

      const [firstLevel] = keys(chosenOption.levels);

      if (chosenOption && firstLevel && chosenOption.levels[firstLevel]) {
        data = {
          numberOfTrialsSecond: chosenOption.count,
          successGroupSecond: chosenOption.levels[firstLevel].name,
          numberOfSuccessSecond: chosenOption.levels[firstLevel].count
        };
      }
    }
    return setDataTwoSampleProportion({ ...data, secondVariable: true })(dispatch);
  },
  handleLevelsOptionsChangeSecond: newLevel => (dispatch, getState) => {
    if (!newLevel) {
      return dispatch(setNumberOfSuccessSecond(valueTwoSampleProportion.numberOfSuccessSecond));
    }

    const state = getState();
    const variableOption = getSecondVariable(state);

    const categoricalSummary = getCategoricalSummary(state);
    const chosenOption = categoricalSummary[variableOption];

    if (variableOption && chosenOption && chosenOption.levels[newLevel]) {
      const numberOfSuccess = chosenOption.levels[newLevel].count;

      return dispatch(setNumberOfSuccessSecond(numberOfSuccess));
    }
    return dispatch();
  },
  handleInputsFirstVariable: () => dispatch => dispatch(resetDropDownsForFirstVariable()),
  handleInputsSecondVariable: () => dispatch => dispatch(resetDropDownsForSecondVariable())
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TwoSampleProportionContainer);
